import React, {Component} from 'react'
import {Popup, Button, Modal, Input, Checkbox} from 'semantic-ui-react'
import Utils from '../../modules/utils'
import {isCustomer} from '../cads/is-role'
import {hideableInfo, hideableInfoCustomer, defaultFields} from './settings-modal'

const pdfUnsupportedFields = ['Pending PO', 'ATS Rep', 'Container #', 'Ex Factory', 'Cost', 'Margin']
const maxPdfFields = 7

class ExportToPdf extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      cadsPerPage: 'One',
      coverText: '',
      coverSubtitle: '',
      showVisibleFields: false,
      excludedFields: []
    }
  }

  open = () => {
    let {cadIds} = this.props
    let ids = Object.keys(cadIds)

    if (ids.length == 0) {
      alert('Please select at least one cad!')
    } else if (ids.length > 200) {
      alert('You have selected ' + ids.length + ' Cads. Limit is 200 Cads!')
    } else {
      this.setState({open: true})
    }
  }

  close = () => {
    this.setState({open: false})
  }

  setCadsPerPage = (cadsPerPage) => {
    this.setState({cadsPerPage})
  }

  inputOnChange = (event, {name, value}) => {
    let newState = {}
    newState[name] = value
    this.setState(newState)
  }

  toggleVisibleFields = () => {
    this.setState({showVisibleFields: !this.state.showVisibleFields})
  }

  //the checkbox for a default field is driven by excludedFields, so the count has to be too,
  //otherwise a default field that also sits in showFields keeps eating a slot while unchecked
  pdfFields = () => (isCustomer() ? hideableInfoCustomer : hideableInfo)
    .filter(field => !pdfUnsupportedFields.includes(field))

  isFieldChecked = (fieldName) => defaultFields.includes(fieldName)
    ? !this.state.excludedFields.includes(fieldName)
    : this.props.showFields.includes(fieldName)

  selectedPdfFields = () => this.pdfFields().filter(this.isFieldChecked)

  showAll = () => {
    let {showFieldOnChange, hideAllFields} = this.props
    let {cadsPerPage} = this.state
    let fields = this.pdfFields()
    //at Six per page you can never check every field, so 7 of 7 counts as "all selected"
    let maxedOut = cadsPerPage == 'Six' && this.selectedPdfFields().length >= maxPdfFields

    if (fields.every(this.isFieldChecked) || maxedOut) {
      hideAllFields()
    } else {
      let selectedCount = this.selectedPdfFields().length

      fields.forEach((field) => {
        if (defaultFields.includes(field) || this.isFieldChecked(field)) return
        if (cadsPerPage == 'Six' && selectedCount >= maxPdfFields) return

        showFieldOnChange(field)
        selectedCount += 1
      })
    }
  }

  downloadPdf = () => {
    let {
      showFields, cadIds, cads, shippedData, salesOrderData, vendorOrders,
      atsRep, contact, fromDate, toDate
    } = this.props
    let {cadsPerPage, coverText, coverSubtitle, excludedFields} = this.state
    let ids = Object.keys(cadIds)
    const selectedCads = cads.filter(cad => ids.includes(cad.i.toString()))
    const styleNumbers = selectedCads.map(cad => cad.s)
    
    const filteredCads = {}
    selectedCads.forEach(cad => {
      filteredCads[cad.i] = cad
    })
    
    const filteredShippedData = Object.entries(shippedData || {}).filter(([key]) =>
      styleNumbers.includes(key)
    )
    
    const filteredSalesOrderDataByStyleNumber = Object.entries(salesOrderData || {}).filter(([key]) =>
      styleNumbers.includes(key)
    )
    
    const filteredSalesOrderDataById = Object.entries(salesOrderData || {}).filter(([key]) =>
      ids.includes(key)
    )
    
    const filteredAtsRep = Object.entries(atsRep || {}).filter(([key]) =>
      ids.includes(key)
    )
    
    const filteredVendorOrders = {}
    selectedCads.forEach(cad => {
      filteredVendorOrders[cad.i] = (vendorOrders || []).filter(order =>
        order.cad_id == cad.i || order.style_number == cad.s || order.s == cad.s
      )
    })

    let selectedPdfFields = this.selectedPdfFields()

    if (cadsPerPage == 'Six' && selectedPdfFields.length > maxPdfFields) {
      alert('Only 7 checked fields can appear on PDF export of 6 CADs per page.')
      return
    }

    const pdfShowFields = [
      ...showFields.filter(f => !defaultFields.includes(f)),
      ...defaultFields.filter(f => !excludedFields.includes(f))
    ]

    const data = {
    cad_ids: ids,
    showFields: pdfShowFields,
    cadsPerPage,
    coverText,
    coverSubtitle,
    isCustomer: isCustomer(),
    cadsData: JSON.stringify(filteredCads),
    shippedData: JSON.stringify(Object.fromEntries(filteredShippedData)),
    salesOrderDataByStyleNumber: JSON.stringify(Object.fromEntries(filteredSalesOrderDataByStyleNumber)),
    salesOrderDataById: JSON.stringify(Object.fromEntries(filteredSalesOrderDataById)),
    atsRep: JSON.stringify(Object.fromEntries(filteredAtsRep)),
    vendorOrders: JSON.stringify(filteredVendorOrders),
    contact,
    fromDate,
    toDate
  }

    Utils.post('export_to_pdf', data, (err, res) =>
    {
      if (err) {
        alert('There was an error when trying to export to pdf.')
      } else {
        window.location = res.data.url
      }
      this.setState({open: false})
    })
  }

  toggleDefaultField = (fieldName) => {
    let {excludedFields} = this.state
    if (excludedFields.includes(fieldName)) {
      excludedFields = excludedFields.filter(f => f != fieldName)
    } else {
      excludedFields = [...excludedFields, fieldName]
    }
    this.setState({excludedFields})
  }

  pdfFieldOnChange = (fieldName) => {
    let {showFieldOnChange} = this.props
    let {cadsPerPage} = this.state

    if (
      cadsPerPage == 'Six' &&
      !this.isFieldChecked(fieldName) &&
      this.selectedPdfFields().length >= maxPdfFields
    ) {
      alert('Only 7 checked fields can appear on PDF export of 6 CADs per page.')
      return
    }

    showFieldOnChange(fieldName)
  }

  render() {
    let {open, cadsPerPage, coverText, coverSubtitle, showVisibleFields} = this.state
    let fields = this.pdfFields()
    let selectedPdfFields = this.selectedPdfFields()
    let disableMoreFields = cadsPerPage == 'Six' && selectedPdfFields.length >= maxPdfFields

    return (
      <React.Fragment>
        <Popup content='Export to PDF' position='right center'
          trigger={
            <Button onClick={this.open} basic circular icon='file pdf outline' style={{marginTop: '2px'}}/>
          }
        />

        <Modal size='large' open={open} onClose={this.close} closeIcon>
          <Modal.Header>Export CADs to PDF</Modal.Header>

          <Modal.Content>
            <Button.Group>
              <Button active={cadsPerPage == 'One'} onClick={() => this.setCadsPerPage('One')}>One</Button>
              <Button active={cadsPerPage == 'Two'} onClick={() => this.setCadsPerPage('Two')}>Two</Button>
              <Button active={cadsPerPage == 'Six'} onClick={() => this.setCadsPerPage('Six')}>Six</Button>
            </Button.Group>
            &nbsp; per Page

            <br/>
            <br/>

            <Input
              name='coverText'
              value={coverText}
              onChange={this.inputOnChange}
              placeholder='Enter Cover Page Title (optional)'
              fluid
            />

            <br/>

            <Input
              name='coverSubtitle'
              value={coverSubtitle}
              onChange={this.inputOnChange}
              placeholder='Enter Cover Page Sub-Title (optional)'
              fluid
            />

            <br/>

            <div style={{cursor: 'pointer'}} onClick={this.toggleVisibleFields}>
              {showVisibleFields ? '▼' : '▶'} Select visible fields
            </div>

            {
              showVisibleFields
              ?
              <div style={{marginTop: '15px'}}>
              <p className="show-hide-note" style={isCustomer() ? {display: 'none'} : {opacity: '0.7'}}>
                Checked fields will be exported. Note: Only 7 checked fields will be able to appear on PDF export of 6 Cads per page!
              </p>
              <div style={{columnCount: '3', zoom: '125%', lineHeight: '200%'}}>
                {fields.map((fieldName, index) => {
                  const isDefault = defaultFields.includes(fieldName)
                  const isChecked = this.isFieldChecked(fieldName)
                  const isDisabled = disableMoreFields && !isChecked
                  return (
                    <div key={index}>
                      <Checkbox
                        disabled={isDisabled}
                        label={fieldName}
                        onChange={isDefault ? () => this.toggleDefaultField(fieldName) : () => this.pdfFieldOnChange(fieldName)}
                        checked={isChecked}
                        style={isDisabled ? {opacity: 0.5} : {}}
                      />
                    </div>
                  )
                })}
                <Button basic style={{padding: '5px 8px', marginTop: '10px'}} onClick={this.showAll}>show all</Button>
              </div>
              </div>
              :
              null
            }
          </Modal.Content>

          <Modal.Actions>
            <Button onClick={this.downloadPdf} primary>
              Download PDF
            </Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    )
  }
}

export default ExportToPdf